/**
 * Timeout Constants
 */

export const AXIOS_TIMEOUT_MS = 30_000;
export const API_TIMEOUT_MS = 30_000;
export const UPLOAD_TIMEOUT_MS = 120_000;
export const DOWNLOAD_TIMEOUT_MS = 60_000;
export const WEBSOCKET_TIMEOUT_MS = 10_000;
export const DEBOUNCE_MS = 300;
export const THROTTLE_MS = 1000;
